import type { IMessageWriter } from '../../../engine/messageWriter'
import { messageWriter } from '../../../engine/messageWriter-sidecar'
import { websockets } from '../../../engine/websockets-sidecar'
import { assert } from '../../../lib/assert-sidecar'
import type { EGolfMessage } from './golfMessageIds'
import { golfMessagePuckMove } from './golfMessagePuckMove-sidecar'
import { golfMessagePuckUpdate } from './golfMessagePuckUpdate-sidecar'
import { golfMessageSetFrame } from './golfMessageSetFrame-sidecar'

export interface IGolfMessageHandler {
  messageId: EGolfMessage
  process: (m: IMessageWriter, isFromHost: boolean, from: number) => void
  test: () => void
}
let _map: { [key: number]: IGolfMessageHandler } = {}
let _list: IGolfMessageHandler[] = []
export function registerAll() {
  register(golfMessageSetFrame)
  register(golfMessagePuckUpdate)
  register(golfMessagePuckMove)
}
function register(mh: IGolfMessageHandler) {
  assert.nil(_map[mh.messageId], 'message handler', mh.messageId)
  _map[mh.messageId] = mh
  _list.push(mh)

  // Test it!
  mh.test()
}

export function process(m: IMessageWriter, skipFrom = false) {
  // TODO: move some of this to engine?
  let from = -1
  if (!skipFrom) {
    let fromB1 = messageWriter.readU8(m)
    let fromB2 = messageWriter.readU8(m)
    from = fromB1 + (fromB2 << 8)
  }

  // Check if this is from the host
  let isFromHost = from === -1 || from === websockets.getHostId()

  let t = messageWriter.peek8(m)

  let handler = _map[t]
  if (handler) {
    handler.process(m, isFromHost, from)
  } else {
    let t1 = messageWriter.read16(m)
    let t2 = messageWriter.read8(m)
    assert.failed('unknown message type', t, t1, t2)
  }
}
